var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { Icons, FillIcons } from './Icons';
import { margin } from '../../utils/margin';
import { useTheme } from '../ThemeProvider/useTheme';
const StyledIcon = styled.span `
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    height: ${(props) => props.size + 'px' || 'inherit'};
    width: ${(props) => props.size + 'px' || 'inherit'};
  }
  ${({ mode, color }) => mode === 'stroke' &&
    ` svg * {
    // fill: transparent;
    stroke: ${color};
  }`}
  ${({ mode, color }) => mode === 'fill' &&
    ` svg * {
    fill: ${color};
    // stroke: transparent;
  }`}

  ${margin}
`;
export const Icon = (_a) => {
    var { name, size = 24, color } = _a, props = __rest(_a, ["name", "size", "color"]);
    const mode = FillIcons.includes(name) ? 'fill' : 'stroke';
    const theme = useTheme();
    return (React.createElement(StyledIcon, Object.assign({ mode: mode, size: size, color: color || theme.colors.content.default }, props), Icons[name]));
};
